import React from "react";
import {useParams} from "react-router";
import {Stack} from "@unibuddy/patron";

import {useChat} from "../providers/ChatProvider";

export function Chat() {
    const {conversationId: idFromParams} = useParams<{conversationId: string}>();
    const {conversationId: idFromContext} = useChat();
    return (
        <Stack space="medium">
            <div>Mock Chat Component</div>
            <div>conversationId from params: {idFromParams}</div>
            <div>conversationId from context: {idFromContext}</div>
            <div>{idFromContext === idFromParams ? "ids match" : "ids don't match"}</div>
        </Stack>
    );
}
